export const isHTMLElement = <TElement extends HTMLElement = HTMLElement>(
  target: unknown
): target is TElement => typeof HTMLElement !== 'undefined' && target instanceof HTMLElement;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Constructor<T> = new (...args: any[]) => T;

export const isNodeListOf = <TElement extends HTMLElement = HTMLElement>(
  target: unknown,
  ctor?: Constructor<TElement> | ((el: unknown) => el is TElement)
): target is NodeListOf<TElement> => {
  if (typeof NodeList === 'undefined' || !(target instanceof NodeList)) {
    return false;
  }
  if (target.length === 0) {
    return true;
  }

  const predicate: (el: unknown) => boolean = (() => {
    if (!ctor) {
      return (el) => typeof HTMLElement !== 'undefined' && el instanceof HTMLElement;
    }
    // ctor may be a constructor (has prototype) or a user-supplied type guard
    // allowing any here to preserve type information in the instanceof check
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof ctor === 'function' && 'prototype' in (ctor as any)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (el) => el instanceof (ctor as any);
    }
    return (el) => (ctor as (el: unknown) => el is TElement)(el);
  })();
  // NodeListOf is iterable, and this is more efficient than forEach with a closure
  // eslint-disable-next-line no-restricted-syntax
  for (const el of target) {
    if (!predicate(el)) {
      return false;
    }
  }
  return true;
};
